function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "M 50,11 C 28.47274,11 11,28.47272 11,50 11,71.5272 28.47274,89 50,89 71.52726,89 89,71.5272 89,50 89,28.47272 71.52726,11 50,11 z m 0,2 C 70.446381,13 87,29.5536 87,50 87,70.4464 70.446381,87 50,87 29.553619,87 13,70.4464 13,50 13,29.5536 29.553619,13 50,13 z M 39,30 c -3.854147,0 -7,3.14584 -7,7 -0.0075,0.528313 0.471635,1.014242 1,1.014242 0.528365,0 1.007472,-0.485929 1,-1.014242 0,-2.77328 2.226729,-5 5,-5 2.77327,0 5,2.22672 5,5 -0.0075,0.528313 0.471635,1.014242 1,1.014242 0.528365,0 1.007472,-0.485929 1,-1.014242 0,-3.85416 -3.145854,-7 -7,-7 z m 22,0 c -3.854146,0 -7,3.14584 -7,7 -0.0075,0.528313 0.471635,1.014242 1,1.014242 0.528365,0 1.007472,-0.485929 1,-1.014242 0,-2.77328 2.22673,-5 5,-5 2.773271,0 5,2.22672 5,5 -0.0075,0.528313 0.471635,1.014242 1,1.014242 0.528365,0 1.007472,-0.485929 1,-1.014242 0,-3.85416 -3.145853,-7 -7,-7 z M 26.8125,50 C 26.297275,50.090402 25.910456,50.640875 26,51.15625 27.920259,63.48485 37.913887,73 50,73 62.086113,73 72.079743,63.48485 74,51.15625 74.090601,50.583371 73.579956,49.992938 73,50 c -15.391421,-10e-7 -30.809846,0 -46.1875,0 z m 1.46875,2 43.4375,0 C 69.506864,62.8557 60.651056,71 50,71 39.348944,71 30.493137,62.8557 28.28125,52 z",
    transform: "translate(0,952.36218)",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.fe4bf717f48082b7cf6ddc69a1110ee8.svg";
export { ForwardRef as ReactComponent };